import React from "react";

function NewsCard(props) {
  return (
    <React.Fragment>
      <a
        href={props.url}
        className="block overflow-hidden rounded-xl border border-gray-200 bg-white p-4 shadow-sm transition-shadow duration-200 hover:shadow-md dark:border-gray-700 dark:bg-gray-800"
      >
        <h3 className="mb-1.5 truncate text-lg font-semibold tracking-tight text-gray-900 dark:text-white">
          {props.title}
        </h3>
        <p className="line-clamp-2 text-sm leading-relaxed text-gray-600 dark:text-gray-400">
          {props.desc}
        </p>
      </a>
    </React.Fragment>
  );
}

export default NewsCard;
